<template>
  <div
    id="withdraw"
    class="menucontent"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div
      class="inmenucontent animate__animated animate__bounceIn"
      :style="{ backgroundImage: createBackgroundString }"
    >
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct px-3">
        <div class="menuhead mb-3">
          <i class="fas fa-minus-circle"></i> ถอนเงิน
        </div>
        <div class="depositimg"></div>

        <div class="selectcontainer animate__animated animate__flipInX">
          <div class="headerbankdt mt-0 mb-0">เลือกช่องทางการถอนเงิน</div>
          <hr class="x-hr-border-glow mb-1 mt-1" />
          <div v-if="awesome === '1'">
            <div
              class="row m-0 mt-2 d-flex justify-content-center"
              v-if="twn.status == 1"
            >
              <div class="col-6 p-0 pr-2" @click="onSetTabSelected('0')">
                <div class="selectwdbox nmwd">
                  <img src="../../assets/icon/bankicon.png" />
                  ถอนเงินเข้าธนาคาร
                </div>
              </div>
              <div class="col-6 p-0 pr-2" @click="onSetTabSelected('1')">
                <div
                  class="selectwdbox1 nmwd mask"
                  style="
                    background-color: linear-gradient(
                      180deg,
                      #a78059 -30%,
                      #f2d7a9 22%,
                      #715236 72%,
                      #f1bb73 112%
                    );
                  "
                >
                  <img src="../../assets/icon/truewallet.svg" />
                  ถอนเงินเข้าtruewallet
                </div>
              </div>
            </div>
            <div class="row m-0 mt-2 d-flex justify-content-center" v-else>
              <div class="col-12 p-0 pr-2" @click="onSetTabSelected('0')">
                <div class="selectwdbox nmwd">
                  <img src="../../assets/icon/bankicon.png" />
                  ถอนเงินเข้าธนาคาร
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="row m-0 mt-2 d-flex justify-content-center"
              v-if="twn.status == 1"
            >
              <div class="col-6 p-0 pr-2" @click="onSetTabSelected('0')">
                <div class="selectwdbox nmwd mask">
                  <img src="../../assets/icon/bankicon.png" />
                  ถอนเงินเข้าธนาคาร
                </div>
              </div>
              <div class="col-6 p-0 pr-2" @click="onSetTabSelected('1')">
                <div class="selectwdbox1 nmwd">
                  <img src="../../assets/icon/truewallet.svg" />
                  ถอนเงินเข้าtruewallet
                </div>
              </div>
            </div>
            <div class="row m-0 mt-2 d-flex justify-content-center" v-else>
              <div class="col-12 p-0 pr-2" @click="onSetTabSelected('0')">
                <div class="selectwdbox nmwd mask">
                  <img src="../../assets/icon/bankicon.png" />
                  ถอนเงินเข้าธนาคาร
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="awesome === '1'">
          <div class="headerbankdt mt-2 mb-0">
            <img src="../../assets/icon/cd.png" /> ถอนเงินเข้า truewallet
          </div>
          <hr class="x-hr-border-glow mb-1 mt-1" />
          <div class="detailwd accountct">
            <table align="center">
              <tbody>
                <tr>
                  <td>
                    <img src="../../assets/icon/truewallet.svg" />
                  </td>
                  <td>
                    ธนาคาร: ทรูมันนี่วอลเล็ท <br />
                    <span
                      >วอลเล็ทไอดี:
                      {{ changePhoneNumber(Auth.twnId) ?? "-" }} </span
                    ><br />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-center mt-3">
            คุณต้องทำยอดเทิร์นอย่างน้อย
            <span id="value_turn_twn" :style="`color: ${colorWithDraw}`">{{
              checkWithDraw(Auth.turnover, Auth.promotionTurn)
            }}</span>
            /
            <span style="color: green">{{ Auth.promotionTurn }}</span>
            เพื่อถอนเงินจากกระเป๋าเงิน
          </div>
          <div class="text-center mt-3 mb-3" style="font-size: 1.3em">
            ยอดเงินคงเหลือ
            <span style="color: #ffce42">฿ {{ Auth.balance }}</span>
          </div>
          <div class="form-group mb-4">
            <input
              type="text"
              id="credit_withdraw"
              :value="Auth.balance"
              class="form-control text-center p-0 py-2"
              style="font-size: 1.2em !important; font-weight: bold"
              disabled
            />
            <div
              class="text-center mt-2"
              style="font-size: 0.8em; color: #ffce42"
            >
              <br />ตามกติกาที่ระบุ
              <a
                class="text-primary condition"
                style="cursor: pointer"
                @click="openTermModal"
                >Term and Condition</a
              >
            </div>
          </div>
          <button
            type="button"
            class="loginbtn mt-0 mb-3"
            @click="onSubmitBank('TMN')"
          >
            <span> ถอนเงิน </span>
            <br />
            <span style="font-size: 10px"
              >( ทำรายการถอน {{ this.withdrawtd }} /
              {{ WebSetting.withdrawtimemax }} ครั้งต่อวัน )</span
            >
          </button>
        </div>
        <!-- <div v-if="awesome === '0' && a"> -->
        <div v-else>
          <button class="backwd"><i class="fas fa-angle-left"></i></button>
          <div class="containdeposit animate__animated animate__flipInX">
            <div class="nmwdcontain">
              <div class="headerbankdt mt-2 mb-0">
                <img src="../../assets/icon/cd.png" /> ถอนเงินเข้าธนาคาร
              </div>
              <hr class="x-hr-border-glow mb-1 mt-1" />
              <div class="detailwd accountct">
                <table align="center">
                  <tbody>
                    <tr>
                      <td>
                        <img :src="checkBankImg(Auth.bank)" />
                      </td>
                      <td>
                        ธนาคาร: {{ Auth.bank }} <br />
                        <span
                          >เลขบัญชี:
                          {{ changeBankNumber(Auth.banknumber) }}</span
                        ><br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center mt-3">
                คุณต้องทำยอดเทิร์นอย่างน้อย
                <span id="value_turn" :style="`color: ${colorWithDraw}`">{{
                  checkWithDraw(Auth.turnover, Auth.promotionTurn)
                }}</span>
                /
                <span style="color: green">{{ Auth.promotionTurn }}</span>
                เพื่อถอนเงินจากกระเป๋าเงิน
              </div>
              <div class="text-center mt-3 mb-3" style="font-size: 1.3em">
                ยอดเงินคงเหลือ
                <span style="color: #ffce42">฿ {{ Auth.balance }}</span>
              </div>
              <div class="form-group mb-4">
                <input
                  type="text"
                  id="credit_withdraw"
                  :value="Auth.balance"
                  class="form-control text-center p-0 py-2"
                  style="font-size: 1.2em !important; font-weight: bold"
                  disabled
                />
                <div
                  class="text-center mt-2"
                  style="font-size: 0.8em; color: #ffce42"
                >
                  <br />ตามกติกาที่ระบุ
                  <a class="text-primary condition" style="cursor: pointer"
                    >Term and Condition</a
                  >
                </div>
              </div>
              <button
                type="button"
                class="loginbtn mt-0 mb-3"
                @click="onSubmitBank('BANK')"
              >
                <span> ถอนเงิน </span>
                <br />
                <span style="font-size: 10px"
                  >( ทำรายการถอน {{ this.withdrawtd }} /
                  {{ this.withdrawmax }} ครั้งต่อวัน )</span
                >
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="rtwdcontain">
               <div class="headerbankdt mt-2 mb-0">
                  <img src="assets/icon/returncd.png"> ถอนเงินคืนยอดเสีย
               </div>
               <hr class="x-hr-border-glow mb-1 mt-1">
               <div class="detailwd accountct">
                  <table align="center">
                     <tbody>
                        <tr>
                           <td>
                              <img src="images/bank/ttb.svg">
                           </td>
                           <td>
                              ธนาคาร: ทหารไทยธนชาต <br>
                              <span>เลขบัญชี: 012-3-45678-1</span><br>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
               <div class="headerbankdt mt-3 mb-1">
                  เงินคืนยอดเสียคงเหลือ 300 บาท
               </div>
               <div class=" form-group mb-4">
                  <div class="el-input">
                     <input type="text" placeholder="ถอนขั้นต่ำ 500 บาท" class="inputstyle text-center p-0 py-2">
                  </div>
               </div>
               <button type="button" class="loginbtn mt-0 mb-3" onclick="location.href='dashboard.php'">
                  <span>
                     ถอนเงิน
                  </span>
               </button>
            </div> -->
      </div>
    </div>
    <div class="overlaymenu"></div>
    <TermModal ref="termmodal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HTTP } from "@/services/http-common";
import TermModal from "@/components/modal/TermModal.vue";

export default {
  name: "withdraw-component",
  components: { TermModal },
  data() {
    return {
      a: false,
      b: false,
      showModal: false,
      isTrueWalletMember: false,
      awesome: "",
      withdrawtd: 0,
      withdrawmax: 0,
      scb: [],
      scb3: [],
      scb5: [],
      kbank: [],
      twn: [],
      BankImg: {
        bbl: require("@/assets/bank/bangkok.svg"),
        kbank: require("@/assets/bank/kbank.svg"),
        ktb: require("@/assets/bank/krungthai.svg"),
        tmb: require("@/assets/bank/tmb.svg"),
        scb: require("@/assets/bank/scb.svg"),
        bay: require("@/assets/bank/krungsri.svg"),
        gsb: require("@/assets/bank/aomsin.svg"),
        baac: require("@/assets/bank/baac.svg"),
        tbank: require("@/assets/bank/tnc.svg"),
        ghb: require("@/assets/bank/ghb.webp"),
        scbt: require("@/assets/bank/scbt.webp"),
        ttb: require("@/assets/bank/ttb.webp"),
        city: require("@/assets/bank/city.webp"),
        cimb: require("@/assets/bank/cimb.webp"),
        uob: require("@/assets/bank/uob.webp"),
        islamic: require("@/assets/bank/islamic.webp"),
        tisco: require("@/assets/bank/tisco.webp"),
        kkp: require("@/assets/bank/kkp.webp"),
        icbc: require("@/assets/bank/icbc.webp"),
        thaicredit: require("@/assets/bank/thaicredit.webp"),
        lh: require("@/assets/bank/lh.svg"),
        truewallet: require("@/assets/bank/truewallet.webp"),
      },
      withdrawstatus: [],
      colorWithDraw: "red",
    };
  },
  methods: {
    openTermModal() {
      this.$refs.termmodal.show();
    },
    show() {
      this.fetchTurnover();
      this.fetchBankDeposit();
      this.fetchUserProfile();
      this.fetchwithdrawtodaycount();
    },
    hide() {
      this.showModal = false;
    },
    checkWithDraw(turnover, promoturn) {
      if (parseInt(turnover) >= parseInt(promoturn)) {
        this.colorWithDraw = "green";
      } else {
        this.colorWithDraw = "red";
      }
      return turnover;
    },
    fetchTurnover() {
      HTTP.get(`member/turnover`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลเทิร์นโอเวอร์ได้ กรุณาลองใหม่"
            );
          } else {
            this.$store.dispatch("saveTurnover", resp.data.turnover);
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลเทิร์นโอเวอร์ได้ กรุณาลองใหม่"
          );
        });
    },
    fetchwithdrawtodaycount() {
      HTTP.get(`member/etcinfo`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("lb_token"),
        },
      })
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลจำนวนรายการถอนวันนี้ของลูกค้าได้ กรุณาลองใหม่"
            );
          } else {
            this.withdrawtd = resp.data.withdrawtodaycount.amount;
            this.withdrawmax = resp.data.withdrawmax.amount;
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.$store.dispatch("logoutAuth");
            } else {
              this.$toast.error(
                err.response.data.msg != undefined
                  ? err.response.data.msg
                  : "ไม่สามารถโหลดข้อมูลจำนวนรายการถอนวันนี้ของลูกค้าได้ กรุณาลองใหม่"
              );
            }
          }
        });
    },
    onSubmitBank(bank) {
      console.log(typeof this.withdrawtd);  // Should be 'number'
      console.log(typeof this.withdrawmax); // Should be 'number'
      let withdrawtd = Number(this.withdrawtd);
      let withdrawmax = Number(this.withdrawmax);
      if (withdrawtd < withdrawmax) {
        let homeCont = this.$refs.homeCont;
        let loader = this.$loading.show({
          container: homeCont,
          loader: "Dots",
          color: "red",
          opacity: 0.5,
          backgroundColor: "#000000",
        });
        HTTP.post(`member/withdraw`, {
          tobank: bank,
        })
          .then((resp) => {
            if (resp.data.status != undefined && !resp.data.status) {
              this.$toast.error(
                resp.data.msg != undefined
                  ? resp.data.msg
                  : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              );
            } else {
              this.$toast.success("แจ้งถอนสำเร็จ");
              this.fetchUserProfile();
              this.showModal = false;
            }
            // document.getElementById("submitBank").disabled = false;
          })
          .catch((err) => {
            this.$toast.error(
              err.data.msg != undefined
                ? err.data.msg
                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
            );
            // document.getElementById("submitBank").disabled = false;
          })
          .finally(() => {
            loader.hide();
          });
      } else {
        this.$toast.error("เกินจำนวนครั้งการถอนสูงสุด");
        return;
      }
    },
    fetchUserProfile() {
      HTTP.get(`member/profile`, {})
        .then((resp) => {
          this.withdrawstatus = resp.data.data;
          if (
            this.withdrawstatus.bank != undefined &&
            this.withdrawstatus.bank == "truewallet"
          ) {
            this.isTrueWalletMember = true;
            this.awesome = "1";
          } else {
            this.isTrueWalletMember = false;
          }
          if (resp.data.status != undefined && resp.data.status) {
            this.$store.dispatch("saveProfile", resp.data.data);
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
          );
        });
    },
    fetchBankDeposit() {
      HTTP.get(`system/bank`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่"
            );
          } else {
            this.scb = resp.data.data[0];
            this.scb3 = resp.data.data[1];
            this.scb5 = resp.data.data[2];
            this.kbank = resp.data.data[3];
            this.twn = resp.data.data[4];
            this.gatewayp = resp.data.data[5];
            this.showModal = true;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลธนาคารได้ กรุณาลองใหม่"
          );
        });
    },
    checkBankImg(bank) {
      if (bank === "กรุงเทพ") return this.BankImg.bbl;
      if (bank === "กสิกรไทย") return this.BankImg.kbank;
      if (bank === "กรุงไทย") return this.BankImg.ktb;
      if (bank === "ทหารไทยธนชาต") return this.BankImg.tmb;
      if (bank === "ไทยพาณิชย์") return this.BankImg.scb;
      if (bank === "ธกส") return this.BankImg.baac;
      if (bank === "กรุงศรีฯ") return this.BankImg.bay;
      if (bank === "ออมสิน") return this.BankImg.gsb;
      if (bank === "ธอส") return this.BankImg.ghb;
      if (bank === "แสตนดาร์ดชาร์เตอร์") return this.BankImg.scbt;
      if (bank === "ซิตี้แบงค์") return this.BankImg.city;
      if (bank === "ซีไอเอ็มบีไทย") return this.BankImg.cimb;
      if (bank === "ยูโอบี") return this.BankImg.uob;
      if (bank === "อิสลาม") return this.BankImg.islamic;
      if (bank === "ทิสโก้") return this.BankImg.tisco;
      if (bank === "เกียรตินาคิณภัทร") return this.BankImg.kkp;
      if (bank === "ไอซีบีซี") return this.BankImg.icbc;
      if (bank === "ไทยเครดิต") return this.BankImg.thaicredit;
      if (bank === "LHBANK") return this.BankImg.lh;
      if (bank === "truewallet") return this.BankImg.truewallet;
    },
    changeBankNumber(number) {
      const set1 = number.substring(0, 3);
      const set2 = number.substring(3, 9);
      const set3 = number.substring(9, 10);
      const sum = `${set1}-${set2}-${set3}`;
      return sum;
    },
    changePhoneNumber(number) {
      const set1 = number.substring(0, 3);
      const set2 = number.substring(3, 7);
      const set3 = number.substring(7, 10);
      const sum = `${set1}-${set2}-${set3}`;
      return sum;
    },
    onSetTabSelected(param) {
      if (!(this.isTrueWalletMember && param == "0")) {
        this.awesome = param;
      }
    },
  },
  computed: {
    ...mapGetters(["Auth"]),
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
    bgStyles() {
      return {
        background: `linear-gradient(152deg, #611b1eb0, #130205), url(
        ${this.img != null ? this.img : this.bgDefault}) top center`,
      };
    },
  },
};
</script>

<style>
.mask {
  animation: glowhead 1.5s infinite alternate;
  background: #cab9e0;
}
@keyframes glowhead {
  from {
    -webkit-filter: drop-shadow(0px 0px 2px rgba(255, 180, 0, 1));
    filter: drop-shadow(0px 0px 2px rgba(255, 139, 0, 1));
  }

  to {
    -webkit-filter: drop-shadow(0px 0px 5px rgba(255, 139, 0, 1));
    filter: drop-shadow(0px 0px 5px rgba(255, 139, 0, 1));
  }
}
</style>
